import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=172353f6&scoped=true&"
import script from "./Popover.vue?vue&type=script&lang=js&"
export * from "./Popover.vue?vue&type=script&lang=js&"
import style0 from "./Popover.vue?vue&type=style&index=0&id=172353f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172353f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('172353f6')) {
      api.createRecord('172353f6', component.options)
    } else {
      api.reload('172353f6', component.options)
    }
    module.hot.accept("./Popover.vue?vue&type=template&id=172353f6&scoped=true&", function () {
      api.rerender('172353f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Popover.vue"
export default component.exports